import { ERequiredFrom } from '@if/core/types'
import { FilteredCreditApplication } from '@src/api/credit-api'
import { areAllDocumentsApproved, hasMissingDocuments } from '@src/data/credit-application-selectors'
import { scrollToTop } from '@src/services/utils'
import { useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'
import CreditStep, { CreditStepStatus } from './CreditStep'

interface DocumentsCreditStepProps {
  creditApp: FilteredCreditApplication
}
const DocumentsCreditStep = ({ creditApp }: DocumentsCreditStepProps) => {
  const { t } = useTranslation()
  const allDocsAreApproved = areAllDocumentsApproved(creditApp)
  const isMissingClientDocs = hasMissingDocuments(creditApp, undefined, ERequiredFrom.Customer)
  const serviceProviderMustSendDocs = hasMissingDocuments(creditApp, undefined, ERequiredFrom.ServiceProvider)
  const status: CreditStepStatus = isMissingClientDocs ? CreditStepStatus.RequiresAttention : CreditStepStatus.Completed
  let desc
  if (isMissingClientDocs) desc = 'overview.moreDocs' as const
  else if (serviceProviderMustSendDocs && !isMissingClientDocs) desc = 'overview.serviceProviderMustSendDocs' as const
  else if (allDocsAreApproved) desc = 'overview.noDocuments' as const
  else desc = 'overview.documentReview' as const

  useLayoutEffect(scrollToTop, [])
  return (
    <CreditStep
      status={status}
      linkToDetail="required-documents"
      hideLinkToDetail={allDocsAreApproved}
      title={t('overview.documentsStep')}
      content={t(desc)}
    />
  )
}

export default DocumentsCreditStep
